module.exports = __webpack_public_path__ + "img/metal.e165a44.jpg";